/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Safe_4_BodyInputs */

const da_forside_safe_4_body = /** @type {(inputs: Forside_Safe_4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data fra appen bruges ikke til at træne AI-modeller, og AI-tjenesten bliver bedt om ikke at gemme svarene.`)
};

/** @type {(inputs: Forside_Safe_4_BodyInputs) => LocalizedString} */
const en_forside_safe_4_body = da_forside_safe_4_body;

/**

* @param {Forside_Safe_4_BodyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_safe_4_body = /** @type {((inputs?: Forside_Safe_4_BodyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Safe_4_BodyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_safe_4_body(inputs)
	return /** @type {LocalizedString} */ ("Data fra appen bruges ikke til at træne AI-modeller, og AI-tjenesten bliver bedt om ikke at gemme svarene.")
});